var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.navigation.activeView !== 'checkerboardAlmostDone',
      expression: "navigation.activeView !== 'checkerboardAlmostDone'"
    }],
    staticClass: "customcheckerboard-button-nav"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    class: ['customcheckerboard-button-nav-cta customcheckerboard-button-nav-cta--first button secondary', {
      expanded: !_vm.isMainApp || _vm.isMobile
    }, {
      disabled: !_vm.enableControls
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardBack) + " ")]), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: {
        placement: 'top-center',
        offset: 8,
        trigger: 'manual',
        show: _vm.isTooltipOpen && _vm.disableNextButton,
        classes: 'customcheckerboard-button-nav-tooltip',
        content: _vm.colorSelectionTooltipContent
      },
      expression: "{\n      placement: 'top-center',\n      offset: 8,\n      trigger: 'manual',\n      show: isTooltipOpen && disableNextButton,\n      classes: 'customcheckerboard-button-nav-tooltip',\n      content: colorSelectionTooltipContent,\n    }"
    }, {
      name: "show",
      rawName: "v-show",
      value: _vm.showNextButton,
      expression: "showNextButton"
    }],
    class: ['customcheckerboard-button-nav-cta button primary', {
      expanded: !_vm.isMainApp || _vm.isMobile
    }, {
      disabled: _vm.disableNextButton || !_vm.enableControls
    }, {
      fullwidth: !_vm.isConfirmDesignViewActive
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v(" " + _vm._s(_vm.translations.customCheckerboardNext) + " "), _c('img', {
    staticClass: "customcheckerboard-button-nav-next-icon",
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-next.svg"),
      "alt": ""
    }
  })]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isConfirmDesignViewActive,
      expression: "isConfirmDesignViewActive"
    }],
    class: ['customcheckerboard-button-nav-cta button primary', {
      expanded: !_vm.isMainApp || _vm.isMobile
    }, {
      disabled: !_vm.enableControls
    }, 'fullwidth'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickFinish
    }
  }, [_vm._v(" " + _vm._s(_vm.translations.customCheckerboardFinish) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }